import PAGES from './page';

const SPEED_MAX_WORD = 50000;

const SPEED_MIN_WORD = 200;

const ai = {
  /** 速读稿件最大字数限制 */
  SPEED_MAX_WORD,
  /** 速读稿件最大字数限制 */
  SPEED_MIN_WORD,
  /** ai工具信息 */
  AI_TOOLS: [
    {
      icon: 'https://oss.5rs.me/oss/uploadfe/png/afed02670d06d55ff1db1896b9698af2.png',
      name: 'AI写作',
      title: '封面/腰封文案，小红书/公众号 推文创作，短视频脚本创作，工作报告/发言稿/作者约稿邮件',
      btnText: '开始创作',
      costRule: '每生成{letters}字，消耗{unitCost}点小睿币',
      writeType: 1,
      id: 1,
      url: PAGES.AI_COPYWRITE
    },
    {
      icon: 'https://oss.5rs.me/oss/uploadfe/png/cf958ef4c7b4d6d791ef7da8595aba92.png',
      name: 'AI审读',
      title: `2分钟，速读${SPEED_MAX_WORD}字。\n自动归纳主题词、摘要`,
      btnText: '开始读稿',
      costRule: '每通读{letters}字，消耗{unitCost}点小睿币',
      writeType: 2,
      id: 2,
      url: PAGES.AI_SPEEDREADING
    },
    {
      icon: 'https://oss.5rs.me/oss/uploadfe/png/b7b2044dfcf07dda25aa20550ab70c10.png',
      name: 'AI画图',
      id: 3,
      writeType: 3,
      title: '封面/插图生成，海报素材生成、商品图生成',
      btnText: '开始创作',
      costRule: '每生成{letters}次 (4张图) ，消耗{unitCost}点小睿币',
      url: PAGES.AI_PAINTING
    },
    {
      icon: 'https://oss.5rs.me/oss/uploadfe/png/cfe425098b6b77f60cb3e7bbf79dd287.png',
      name: 'AI有声书',
      title: '文本转真人语音，自然饱满，支持各国语言，英语（英/美式）日语、韩语等',
      btnText: '开始创作',
      writeType: 4,
      id: 4,
      costRule: '每生成{letters}字，消耗{unitCost}点小睿币',
      url: PAGES.AI_TEXT2SPEECH
    },
    {
      icon: 'https://oss.5rs.me/oss/uploadfe/png/effca1dfeb16cbf1c9c8a2dd3aa94a2a.png',
      name: 'AI做视频',
      title: '文本生成视频\nAI数字人讲解',
      id: 5,
      disabled: true,
      btnText: '催开发'
    },
    {
      icon: 'https://oss.5rs.me/oss/uploadfe/png/c7d6a47c3cd7e946271d9d20d8141f17.png',
      name: 'AI审校',
      title: '文本审校，音频审校、视频审校',
      id: 6,
      disabled: true,
      btnText: '催开发'
    }
  ],
  // 拼音纠正时，会有非标准拼音，后端解析不了，以下是过滤不了的拼音
  FILTER_ARR: ['r2']
};

export default ai;
